module.exports = __webpack_public_path__ + "img/tarteSugar2.402b5349.jpg";